import { render, staticRenderFns } from "./format.vue?vue&type=template&id=9e0ba650&"
import script from "./format.vue?vue&type=script&lang=js&"
export * from "./format.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports